import type { TabsProps } from 'antd';
import { Tabs } from 'antd';
import React from 'react';
import BSPBill_Compare from './BSPBill_Compare';
import BSPBill_List from './BSPBill_List';

const onChange = (key: string) => {
  console.log(key);
};

const items: TabsProps['items'] = [
  {
    key: '1',
    label: 'BSP  Importing',
    children: (
      <>
        <BSPBill_List />
      </>
    ),
  },
  {
    key: '2',
    label: 'BSP Bill Reconciliation',
    children: (
      <>
        <BSPBill_Compare />
      </>
    ),
  },
];

const BSPReportTab: React.FC = () => (
  <Tabs defaultActiveKey='1' items={items} onChange={onChange} />
);

export default BSPReportTab;
